import AIIcon from '@mdi/svg/svg/creation.svg?react';
import { IconWithTooltip, useKeyActions } from '@solinkcorp/solink-components';
import { useAiChatStore } from '@solinkcorp/solinkii/aiChatStore';
import Loadable from 'components/Loadable';
import { useMemo } from 'react';
import { useIfEverTrue } from 'src/hooks/useIfEverTrue';
import useLocale from 'src/hooks/useLocale';
import './AIChat.sass';

const Solinkii = Loadable({
  loader: () =>
    import('@solinkcorp/solinkii/Solinkii').then((module) => ({ default: module.Solinkii })),
});

export default function AIChat() {
  const { toggleOpen, isOpen, close } = useAiChatStore();
  const locale = useLocale();
  const hasBeenOpened = useIfEverTrue(isOpen);

  useKeyActions(
    useMemo(
      () => [
        {
          shortcut: 'mod+i',
          action: toggleOpen,
          info: {
            title: 'Open AI Chat',
            group: 'AI Chat',
          },
        },
        {
          shortcut: 'escape',
          action: () => close(),
          visible: isOpen,
          info: {
            title: 'Close AI Chat',
            group: 'AI Chat',
          },
        },
      ],
      [close, isOpen, toggleOpen],
    ),
  );

  return (
    <>
      <IconWithTooltip
        className="ai-chat"
        title={locale.AIChat?.askAIChat || 'Ask AI Chat'}
        icon={AIIcon}
        iconSize={18}
        onClick={toggleOpen}
      />

      {hasBeenOpened && <Solinkii />}
    </>
  );
}
